
import React from 'react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
  SidebarHeader
} from "@/components/ui/sidebar";
import { Book, ChevronLeft } from 'lucide-react';

interface Study {
  id: string;
  title: string;
  date: string;
}

interface StudiesSidebarProps {
  studies: Study[];
  activeStudyId: string;
  onSelectStudy: (id: string) => void;
}

export const StudiesSidebar = ({ studies, activeStudyId, onSelectStudy }: StudiesSidebarProps) => {
  return (
    <Sidebar>
      <SidebarHeader className="flex items-center">
        <SidebarTrigger className="ml-auto" />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Stewie Insights</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {studies.map((study) => (
                <SidebarMenuItem key={study.id}>
                  <SidebarMenuButton 
                    isActive={study.id === activeStudyId}
                    onClick={() => onSelectStudy(study.id)}
                  >
                    <Book className="h-4 w-4" />
                    <span>{study.title}</span>
                    <span className="ml-auto text-xs text-slate-500">{study.date}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};
